import { render, staticRenderFns } from "./MeTab.vue?vue&type=template&id=b0b56a80"
import script from "./MeTab.vue?vue&type=script&lang=js"
export * from "./MeTab.vue?vue&type=script&lang=js"
import style0 from "./MeTab.vue?vue&type=style&index=0&id=b0b56a80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports